import * as React from 'react';
import { Link } from 'react-router-dom';
import Project from 'src/entities/Project';
import * as moment from 'moment';
import './ProjectCard.css';
import ImageContainer from 'src/modules/commons/images/Image.container';

interface Props {
  project: Project;
  status: string;
}

class ProjectCardComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {

    let percentageInvested;

    if (this.props.project.cashTarget === 0) {
      percentageInvested = 125;
    } else {
      percentageInvested = Math.round(this.props.project.cash / this.props.project.cashTarget * 100) <= 125 ?
        Math.round(this.props.project.cash / this.props.project.cashTarget * 100) : 125;
    }

    const progressBarStyle = {
      width: Math.min(percentageInvested, 100).toLocaleString() + '%'
    };

    const remainingTime = Math.max(
      moment.utc(this.props.project.endDate, 'YYYY-MM-DD').diff(moment(moment()).subtract(2, 'days'), 'days'),
      0
    );

    return (
      <section>
        {this.props.status === 'open' ?
          <div className="col-xs-12 col-sm-6 col-md-4 project-card-component">
            <div className="project-card">
              <Link to={'/ficha-de-operaciones/' + this.props.project.id}>
                <div className="image-resume">
                  <ImageContainer
                    alt={this.props.project.company.name + ' logo'}
                    className="img-responsive"
                    url={this.props.project.company.logo}
                  />
                </div>
                <div className="content">
                  <h3>
                    {/*TODO when this is a thing add the label*/}
                    {/*<span className="label label-default label-card">
                      Incentivo Fiscal
                </span>*/}
                    {this.props.project.company.name}
                  </h3>
                  <p
                    style={{
                      display: 'block',
                      textOverflow: 'ellipsis',
                      wordWrap: 'break-word',
                      overflow: 'hidden',
                      maxHeight: '4.24em'
                    }}
                  >
                    {this.props.project.company.description}
                  </p>
                </div>
                <div>
                  <p className="lead c-black-text text-center force-down f-s-26">
                    <span className="bk-w">
                      {this.props.project.cashTarget.toLocaleString('es')} €
              </span>
                  </p>
                  <hr />
                </div>
                <div className="gap-10" />
                <p className="text-center margin-bottom-0">
                  <strong>
                    {this.props.project.cash.toLocaleString('es')} €
                  </strong>
                  &nbsp;financiado
                </p>

                <div className="row">
                  <div className="col-xs-9">
                    <div className="progress-bar-border">
                      <div className="progress-bar" style={progressBarStyle} />
                    </div>
                  </div>
                  <div className="col-xs-3">
                    <span className="c-primary progress-bar-value">
                      {
                        Math.round(this.props.project.cash / this.props.project.cashTarget * 100)
                          .toLocaleString() + ' %'
                      }
                    </span>
                  </div>
                </div>
                <div className="gap-20" />
                <div className="row">
                  <div className="col-xs-4 text-center">
                    <p>
                      <span className="small">
                        Capital
                </span>
                      <br />
                      <strong>
                        {this.props.project.capital}
                      </strong>
                    </p>
                  </div>
                  <div className="col-xs-4 text-center border-left border-right">
                    <p>
                      <span className="small">
                        Inversores
                </span>
                      <br />
                      <strong>
                        {this.props.project.numberInvestors}
                      </strong>
                    </p>
                  </div>
                  <div className="col-xs-4 text-center">
                    <p>
                      <span className="small">
                        Días restantes
                </span>
                      <br />
                      <strong>
                        {remainingTime}
                      </strong>
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          :
          <div className="col-xs-12 col-sm-6 col-md-4 project-card-component">
            <div className="project-card">
              <div className="ribbon ribbon-top-right">
                <span>
                  <p>
                    Operación finalizada
                </p>
                </span>
              </div>
              <Link to={'/ficha-de-operaciones/' + this.props.project.id}>
                <div className="image-resume">
                  <ImageContainer
                    alt={this.props.project.company.name + ' logo'}
                    className="img-responsive"
                    url={this.props.project.company.logo}
                  />
                </div>
                <div className="content">
                  <h3>
                    {/*TODO when this is a thing add the label*/}
                    {/*<span className="label label-default label-card">
                      Incentivo Fiscal
                </span>*/}
                    {this.props.project.company.name}
                  </h3>
                  <p>
                    {this.props.project.company.description}
                  </p>
                </div>
                <div>
                  <p className="lead c-black-text text-center force-down f-s-26">
                    <span className="bk-w">
                      {this.props.project.cash.toLocaleString('es')} €
              </span>
                  </p>
                  <hr />
                </div>
                <div className="gap-10" />
                <p className="text-center margin-bottom-0">
                  <span className="c-primary progress-bar-value">
                    {percentageInvested.toLocaleString() +
                      ' % invertido'}
                  </span>
                </p>

                <div className="row">
                  <div className="col-md-12">
                    <div className="progress-bar-border">
                      <div className="progress-bar" style={progressBarStyle} />
                    </div>
                  </div>
                </div>
                <div className="gap-20" />
              </Link>
            </div>
          </div>
        }
      </section>
    );
  }
}

export default ProjectCardComponent;



// WEBPACK FOOTER //
// ./src/modules/projects/partials/ProjectCard.component.tsx